<template>
  <main class="html-page home-page blog-page article-page">
    <section class="page-hero blog-hero" data-bloco="blog-hero" data-tipo="hero">
      <div class="container blog-hero-grid">
        <div class="blog-hero-copy">
          <p class="eyebrow" data-campo="iti_nome" v-html="html(blogHero, 'iti_nome')"></p>
          <h1 data-campo="iti_resumo1" v-html="html(blogHero, 'iti_resumo1')"></h1>
          <p data-campo="iti_descricao1" v-html="html(blogHero, 'iti_descricao1')"></p>
        </div>
        <div class="blog-hero-media">
          <img v-if="image(blogHero)" :alt="text(blogHero, 'iti_nome')" data-img="imagem" :src="image(blogHero)" @error="hideBrokenImage">
        </div>
      </div>
    </section>

    <template v-if="article">
      <section class="article-content-section">
        <div class="container article-layout blog-detail-layout">
          <article class="article-reading">
            <router-link class="article-back blog-detail-back" to="/blog">← Voltar ao Blog</router-link>
            <span v-if="html(article, 'iti_campo_extra2')" class="tag" v-html="html(article, 'iti_campo_extra2')"></span>
            <h1 class="blog-detail-title" v-html="html(article, 'iti_nome')"></h1>
            <div v-if="html(article, 'iti_resumo1')" class="article-lead" v-html="html(article, 'iti_resumo1')"></div>
            <div class="article-meta">
              <span v-if="html(article, 'iti_campo_extra1')" v-html="html(article, 'iti_campo_extra1')"></span>
            </div>
            <img v-if="image(article)" class="article-cover" :src="image(article)" :alt="text(article, 'iti_nome')" @error="hideBrokenImage">
            <div class="blog-detail-content" v-html="html(article, 'iti_descricao1')"></div>
            <div class="article-share">
              <strong>Compartilhe este conteúdo</strong>
              <a :href="shareLink" target="_blank" rel="noopener">Compartilhar pelo WhatsApp</a>
            </div>
          </article>
        </div>
      </section>
    </template>
    <section v-else-if="loaded" class="section">
      <div class="container blog-detail-not-found">
        <h1>Conteúdo não encontrado.</h1>
        <router-link class="btn btn-primary" to="/blog">Voltar ao Blog</router-link>
      </div>
    </section>
    <a class="whatsapp" href="https://wa.me/5551991544590" aria-label="Falar pelo WhatsApp"><span></span></a>
  </main>
</template>

<script>
import {
  contentValue,
  firstImage,
  getInstitutionalContent,
  plainText,
  applyPageMeta,
} from '@/services/contentApi';

export default {
  name: 'BlogDetalheView',
  data() {
    return {
      blogHero: {},
      article: null,
      loaded: false,
    };
  },
  computed: {
    shareLink() {
      const url = typeof window === 'undefined' ? '' : window.location.href;
      const title = plainText(contentValue(this.article, 'iti_nome'));
      return 'https://wa.me/?text=' + encodeURIComponent([title, url].filter(Boolean).join(' - '));
    },
  },
  watch: {
    '$route.params.id': 'loadArticle',
  },
  created() {
    this.loadArticle();
  },
  methods: {
    hideBrokenImage(event) { event.currentTarget.hidden = true; },
    text(source, field) {
      return plainText(contentValue(source, field));
    },
    html(source, field) {
      return contentValue(source, field);
    },
    image(source) {
      return firstImage(source);
    },
    async loadArticle() {
      this.loaded = false;
      const [blogHero, items] = await Promise.all([
        getInstitutionalContent(25, false),
        getInstitutionalContent(26, true),
      ]);
      this.blogHero = blogHero;
      const id = String(this.$route.params.id || '');
      this.article = items.find((item) => String(item.itiId ?? item.iti_id ?? '') === id) || null;
      this.loaded = true;
      if (this.article) {
        applyPageMeta({
          title: contentValue(this.article, 'iti_nome'),
          description: contentValue(this.article, 'iti_resumo1'),
          image: firstImage(this.article),
          type: 'article',
        });
      }
    },
  },
};
</script>

<style scoped>
.blog-detail-layout {
  grid-template-columns: minmax(0, 900px);
}
.blog-detail-back {
  display: flex;
  width: max-content;
  margin-bottom: 28px;
  padding: 11px 18px;
  border: 1px solid #dfd1e3;
  border-radius: 999px;
  background: #fff;
}
.article-reading > .tag {
  display: inline-block;
  margin-bottom: 18px;
}
.blog-detail-title {
  margin: 16px 0 18px;
  font-size: clamp(2.2rem, 5vw, 4.2rem);
  line-height: 1.04;
  letter-spacing: -.045em;
}
.article-meta {
  margin-bottom: 30px;
}
.blog-detail-content :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 18px;
}
.blog-detail-not-found {
  text-align: center;
}
.blog-detail-not-found .btn {
  margin-top: 20px;
}
</style>
